import React from 'react';
import agent from '../../../../agent';
import GuageChartWidget from './GuageChartWidget'
import LoaderWidget from '../Loader/LoaderWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'

class GuageChartWidgetContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      search: {
        rows:[],
        headers:[]
      },
      loaded:false
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    this.runSearch(this.props.savedSearchId, "table", this.props.bypassCache);
  }

  runSearch(savedSearchId, searchResultType, bypassCache) {
    agent.Search.executeSearch(savedSearchId, searchResultType, bypassCache).then(
      res => {
        if(res.result) {
          this.setState({
            ...this.state,
            'search':res.data,
            'loaded':true
          })
        } else {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error, agent)) {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      }
    )

  }


  render() {
    if(this.state.loaded) {
      return (
        <GuageChartWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} search={this.state.search} />
      )
    } else {
      return (
        <LoaderWidget {...this.props}/>
      )
    }

  }
}

export default GuageChartWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/GuageChartWidget/GuageChartWidgetContainer.js